import React, { Component, Fragment } from "react";
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { withStyles } from "@material-ui/core/styles";
import "moment/locale/es";
import moment from "moment";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import IconButton from "@material-ui/core/IconButton";
import consentPdf from "./PdfReports/PdfConsent";
import pdfAdmsionFormat from "./PdfReports/PdfAdmisionFormat";
import pdfFormula from "./PdfReports/PdfFormula";
import pdfClincHistory from "./PdfReports/PdfHistory";
import pdfEvent from "./PdfReports/PdfEvent";
import pdfProceduresFormat from "./PdfReports/PdfProceduresFormat";
import generatePdf from "../../ClinicHistoryViewNuclear/components/Imagenologia/GeneratePdf";
import PDFTranscription from "../../../AudioPanel/PDFTranscription";
import PrintsProceduresPDF from "../../ClinicHistoryViewIPS/components/MedicalProcedures/PrintsProceduresPDF";
import InformedConsentPDF from "../../../Admissions/SearchAdmissions/components/InformedConsentPDF";
import SpeechTerapyPDF from "../../ClinicHistoryViewIPS/components/SpeechTerapy/SpeechTerapyPDF";
import { calculateAgeParse } from "../../../Utils/Patient";
import pdfPrintInfoLetterProcedure from "./PdfReports/pdfPrintInfoLetterProcedure";
import classnames from "classnames";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Spinner from "react-bootstrap/Spinner";
import TagsInput from "./TagsInput";
import incapacityPDF from "../../ClinicHistoryViewIPS/components/MedicalIncapacity/incapacityPDF";
import SendEmails from "./EmailSender/SendEmails";
import pdfYodo from "./PdfReports/PdfYodo";

const styles = (theme) => ({
  date: {
    margin: 10,
    width: 215,
  },
});

class ShowClinicEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeOfDocument: "",
      documentNumber: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      gender: "",
      bloodType: "",
      age: "",
      date: new Date(),
      birthday: null,
      today: new Date(),
      day: new Date(),
      civilStatus: "",
      race: "",
      ethnicity: "",
      city: "",
      address: "",
      telephone1: "",
      telephone2: "",
      cellphone: "",
      email: "",
      regime: this.props.data.regimen_admision ?? "",
      urlLogo: sessionStorage.getItem("logoURL"),
      anamnesis: [],
      antecedentes: [],
      diagnostico: [],
      ordenes: [],
      fisico: [],
      plan: [],
      procedimientos: [],
      id_profesional: "",
      sistemas: null,
      professional: [],
      admissions: [],
      serter: [],
      profile: [],
      id_patient: null,
      id_history: null,
      exist: false,
      openShowMore: true,
      showPDf: false,
      history: "",
      description: "",
      tecnic: "",
      opinion: "",
      observation: "",
      note: "",
      services: [],
      third: [],
      listTypes: JSON.parse(sessionStorage.getItem("centroTipos")),
      firmTech: "",
      firmDoctor: "",
      fullnameDoctor: "",
      fullnameTech: "",
      speechTerapy: null,
      radioPharmacy: null,
      medicalRegister: null,
      clinicNotes: [],
      validateService: false,
      validateTerapy: false,
      nameProcedure: "",
      transcriptionData: null,
      isConsulta: false,
      informedConsent: null,
      eventClinicProcedures: null,
      resultProceduresAllClinicHistory: [],
      infoAdmissionPatient: null, // Informacion de la admisión del paciente agenda/consultarpaciente
      userPermits: [],
      speechTerapyData: null,
      existServicesProcedures: {
        eco: false,
        stress: false,
        test: false,
        holter: false,
        mapa: false,
        ekg: false,
      },
      activeTab: "1",
      emailDestiny: null,
      loadingSendEmail: false,
      correosEnviar: [],
      correosEnviados: false,
      incapacityByThisAdmission: null,
      filesProceduresByThisAdmission: null,
      showFileProcedure: false,
      showSelectedFile: null,
      medicoApoyo: null,
      firmDoctorGet: null,
      firmDoctorSupport: [],
      occupation: null,
      disability: null,
      poblacionVulnerable: null,
      certificateYodo: false,
    };
  }

  componentDidMount = () => {
    this.validateUserPermits();
    this.getPrintEvent();
    this.getClinicHistory();
    this.loadDataProfile();
    this.getNuclearHistory();
    this.loadDataCita();
    this.loadFirm();
    this.validateService();
    this.validateTerapy();
    this.loadIncapacityByThisAdmission();
    this.loadFileProcedure();
    this.definePaientsEmailToSend();
    //this.getEmailsPatient();
    //this.getResultsClinicHistory();

    let proceduresVerify = this.verifyAdmisionProceduresApply(
      this.props.data.servicios
    );
    this.setState({
      existServicesProcedures: proceduresVerify,
    });

    if (this.props.data.correo != null && this.props.data.correo != undefined) {
      this.setState({ correosEnviar: [this.props.data.correo] });
    }
  };

  getEmailsPatient = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "paciente/consultar-correos-paciente?id_historia=" +
        this.props.data.id_historia,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("dataCorreos", data);
        this.setState({ correosEnviar: data });
      })
      .catch((error) => {
        console.error("dataCorreosError:", error);
      });
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab, showPDf: false });
    }
  };

  verifyAdmisionProceduresApply = (servicios) => {
    try {
      let dataProc = {
        eco: servicios.some((ser) => parseInt(ser.formato) == 1),
        stress: servicios.some((ser) => parseInt(ser.formato) == 3),
        test: servicios.some((ser) => parseInt(ser.formato) == 4),
        holter: servicios.some((ser) => parseInt(ser.formato) == 6),
        mapa: servicios.some((ser) => parseInt(ser.formato) == 7),
        ekg: servicios.some((ser) => parseInt(ser.formato) == 2),
      };
      return dataProc;
    } catch (e) {
      return {
        eco: false,
        stress: false,
        test: false,
        holter: false,
        mapa: false,
        ekg: false,
      };
    }
  };

  validateUserPermits() {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        this.setState({ userPermits: perfil });
      } else {
        var perfil = [];
        this.setState({ userPermits: [] });
      }
    } else {
      this.setState({ userPermits: [] });
    }
  }

  validateTerapy = () => {
    let isTerapia = this.props.data.servicios.some((ser) => {
      return ser.nombre.toUpperCase().includes("TERAPIA");
    });
    this.setState({ validateTerapy: isTerapia });
  };

  validateService = () => {
    if (this.props.data.pertenece_estudio != true) {
      let validateGamagrafia = this.props.data.servicios.some((ser) => {
        let verifyCups = ser.codigo ?? ser.cupscod;
        let verifyAislamiento = ser.ind_hospitalizacion;
        let isTerapia = ser.nombre.toUpperCase().includes("TERAPIA");

        if (
          isTerapia &&
          (verifyAislamiento === false || verifyAislamiento === null)
        ) {
          return true;
        }

        return (
          ser.nombre.toUpperCase().search("GAMAGRAFIA") != -1 ||
          (verifyCups.startsWith("92") && !verifyCups.startsWith("9228"))
        );
      });
      this.setState({ validateService: validateGamagrafia }, () => {
        if (this.state.validateService) this.getTranscription();
      });

      if (validateGamagrafia !== true) {
        let validateConsulta = this.props.data.servicios.some((ser) => {
          let verifyAislamiento = ser.ind_hospitalizacion;
          return (
            ser.nombre.toUpperCase().search("CONSULTA") != -1 ||
            (ser.nombre.toUpperCase().search("TERAPIA") != -1 &&
              verifyAislamiento === true)
          );
        });

        if (validateConsulta !== true) {
          //this.setState({ validateService: true });

          let nameProcedure = this.props.data.servicios[0].nombre.split(" ");
          let cupProcedure = this.props.data.servicios[0].codigo;
          let searchname = nameProcedure.filter(
            (name) =>
              name === "ELECTROCARDIOGRAFIA" ||
              name === "ECOCARDIOGRAMA" ||
              name === "ELECTROCARDIOGRAMA" ||
              name === "MONITOREO" ||
              name === "PRUEBA"
          );

          if (
            searchname.includes("ELECTROCARDIOGRAFIA") ||
            cupProcedure === "895001"
          ) {
            this.setState({ nameProcedure: "HOLTER" }); //895001 ELECTROCARDIOGRAFIA DINAMICA (HOLTER)
          } else if (
            searchname.includes("ECOCARDIOGRAMA") ||
            cupProcedure === "891234" ||
            cupProcedure === "881233" ||
            cupProcedure === "881202"
          ) {
            this.setState({ nameProcedure: "ECO" }); //891234 ECOCARDIOGRAMA MODO M Y BIDIMENSIONAL CON DOPPLER A COLOR 881233 881202
          } else if (
            searchname.includes("ELECTROCARDIOGRAMA") ||
            cupProcedure === "895100"
          ) {
            this.setState({ nameProcedure: "EKG" }); //895100 ELECTROCARDIOGRAMA DE RITMO O DE SUPERFICIE SOD
          } else if (
            searchname.includes("MONITOREO") ||
            cupProcedure === "896100" ||
            cupProcedure === "896101" ||
            cupProcedure === "895004"
          ) {
            this.setState({ nameProcedure: "MAPA" }); //896100 MONITOREO AMBULATORIO DE PRESIÓN ARTERIAL SISTÉMICA (TELEMETRÍA) 896101 895004
          } else if (
            searchname.includes("PRUEBA") ||
            cupProcedure === "894102"
          ) {
            this.setState({ nameProcedure: "TEST" }); //894102 PRUEBA DE ESFUERZO CARDIOVASCULAR
          } else {
            this.setState({ nameProcedure: "STRESS" }); //
          }
        } else {
          this.setState({ isConsulta: validateConsulta });
        }
      }
    } else {
      //Esteban Londoño Ospina 22/07/2022
      //Consulta QUEMADA si es un Estudio Clinico
      this.setState({ isConsulta: true });
    }
  };

  loadFileProcedure = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "procedimientos-adjunto/consultar?id_admision=" +
          this.props.data.id_admision,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error Data");
          }
        })
        .then((dataAdjunto) => {
          if (dataAdjunto.adjunto != null) {
            this.defineFilesForProcedures(dataAdjunto.adjunto);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  defineFilesForProcedures = (adjuntos) => {
    let filesWithWholeUrl = adjuntos.map((adjunto) => {
      adjunto.wholeURL =
        process.env.REACT_APP_PUBLIC_URL +
        adjunto.url_adjunto +
        sessionStorage.getItem("token");
      return adjunto;
    });
    this.setState({ filesProceduresByThisAdmission: filesWithWholeUrl });
  };

  filteredResultsWholeClinicHistory = () => {
    if (
      this.state.admissions.length > 0 &&
      this.state.resultProceduresAllClinicHistory.length > 0
    ) {
      let admisiones = this.state.admissions;
      let resultsProcedures = this.state.resultProceduresAllClinicHistory;
      let mix = [];
      let resultsToprint = [];
      admisiones.map((add) => {
        var newElement = resultsProcedures.find(
          (pro) => pro.admision.id_admision === add.id_admision
        );
        if (newElement !== undefined) mix.push(newElement);
      });

      mix.map((add) => {
        var newElement = admisiones.find(
          (admsn) => admsn.id_admision === add.admision.id_admision
        );
        //newElement['procedimientos': ]
        console.log("NewElement", newElement);
        //admisiones = [...admisiones],
      });
    }
  };

  loadDataProfile = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "clinica/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          this.setState({
            profile: data[0],
            //urlLogo: process.env.REACT_APP_PUBLIC_URL + "clinica/" + data[0].id_clinica + "/logo/" + sessionStorage.getItem('token')
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  getPrintEvent = async () => {
    const dataSend = {
      id_historia: this.props.data.id_historia,
      id_admision: parseInt(this.props.data.id_admision),
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "evento/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setDataClinicEvent(data);
        this.setState(
          {
            eventClinicProcedures: data.contenido.procedimientos,
            speechTerapyData: data.contenido.audiometria,
          },
          () => {
            console.log("Procedimientos", this.state.eventClinicProcedures);
          }
        );
      })
      .catch((error) => {
        alert(error);
        console.error("Error:", error);
      });
  };

  getClinicHistory = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "evento/consultar/historia_clinica/" +
        this.props.data.id_historia,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ admissions: data.admisiones });
        this.setState({ disability: data.paciente });
        this.setState({ poblacionVulnerable: data.paciente?.nombre });
      })
      .catch((error) => {
        alert(error);
        console.error("Error:", error);
      });
  };

  getResultsClinicHistory = () => {
    fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "historia/consultar-procedimientos?id_historia=" +
        this.props.data.id_historia,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ resultProceduresAllClinicHistory: data.data }, () =>
          this.filteredResultsWholeClinicHistory()
        );
      })
      .catch((error) => {
        alert(error);
        console.error("Error:", error);
      });
  };

  getNuclearHistory = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "historia-medicinanuclear/consultar-por-admision?id_historia=" +
        this.props.data.id_historia +
        "&id_admision=" +
        this.props.data.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          console.log("eje");
          this.setState({
            history: data[0].antecedentes,
            tecnic: data[0].tecnica,
            description: data[0].descripcion,
            opinion: data[0].opinion,
            observation: data[0].observacion,
            note: data[0].nota,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadFirm = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/consultar-firmas?id_admision=" +
        this.props.data.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.firmas != null && data.firmas != undefined) {
          console.log("datafirma", data.firmas);
          let url_doctor =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_firma_doctor +
            "/" +
            sessionStorage.getItem("token");
          let url_tecnologo =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_tecnologo +
            "/" +
            sessionStorage.getItem("token");
          let firmDoctorSupportGet = data.firmas.medico_apoyo.map((medico) => {
            return (
              process.env.REACT_APP_PUBLIC_URL +
              medico.url_firma_doctor_alter +
              "/" +
              sessionStorage.getItem("token")
            );
          });
          this.setState({
            firmTech: url_tecnologo,
            firmDoctor: url_doctor,
            fullnameDoctor: data.firmas.nombre_doctor,
            fullnameTech: data.firmas.tecnologo_nombre,
            medicoApoyo: data.firmas.medico_apoyo,
            firmDoctorGet: data.firmas.url_doctor,
            firmDoctorSupport: firmDoctorSupportGet,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  setDataClinicEvent = (data) => {
    this.setState({
      typeOfDocument: data.contenido.pacientes.tip_documento,
      documentNumber: data.contenido.pacientes.num_documento,
      names: data.contenido.pacientes.nombres,
      firstLastName: data.contenido.pacientes.apellido1,
      secondLastName: data.contenido.pacientes.apellido2,
      gender: data.contenido.pacientes.sexo,
      city: data.contenido.pacientes.direccion.ciudad,
      address: data.contenido.pacientes.direccion.direccion,
      telephone: data.contenido.pacientes.telefono1,
      cellphone: data.contenido.pacientes.celular,
      email: data.contenido.pacientes.correo,
      civilStatus: data.contenido.pacientes.e_civil,
      bloodType: data.contenido.pacientes.tipo_sangre,
      anamnesis: data.contenido.anamnesis,
      antecedentes: data.contenido.antecedentes,
      diagnostico: data.contenido.diagnostico,
      fisico: data.contenido.fisico,
      procedimientos: data.contenido.procedimientos,
      sistemas: data.contenido.sistemas,
      plan: data.contenido.plan, // Analisis, plan medico y recomendaciones
      ordenes: data.contenido.ordenes,
      professional: data.contenido.profesional,
      id_profesional: data.contenido.id_profesional,
      speechTerapy: data.contenido.audiometria,
      radioPharmacy: data.contenido.radiofarmaco,
      medicalRegister: data.contenido.registro_clinico,
      clinicNotes: data.contenido.notas_clinicas,
      occupation: data.contenido.pacientes.ocupacion,
    });
    this.calculateAge(data.contenido.pacientes.fec_nacimiento);
    this.Loadethnicity(data.contenido.pacientes.id_etnia);
    this.LoadRace(data.contenido.pacientes.id_raza);
  };

  loadDataFirm = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/consultar-firmas?id_admision=" +
        this.state.infoPaciente.admision.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.firmas != null && data.firmas != undefined) {
          let url_doctor =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_firma_doctor +
            "/" +
            sessionStorage.getItem("token");
          let url_tecnologo =
            process.env.REACT_APP_PUBLIC_URL +
            data.firmas.url_tecnologo +
            "/" +
            sessionStorage.getItem("token");
          let firmDoctorSupportGet = data.firmas.medico_apoyo.map((medico) => {
            return (
              process.env.REACT_APP_PUBLIC_URL +
              medico.url_firma_doctor_alter +
              "/" +
              sessionStorage.getItem("token")
            );
          });
          this.setState({
            firmDoctorGet: url_doctor,
            medicoApoyo: data.firmas.medico_apoyo,
            firmDoctorSupport: firmDoctorSupportGet,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  Loadethnicity = (id) => {
    const sendData = { id: id };

    fetch(process.env.REACT_APP_PUBLIC_URL + "etnia/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ ethnicity: data.contenido[0].etnia });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  LoadRace = (id) => {
    const sendData = { id: id };

    fetch(process.env.REACT_APP_PUBLIC_URL + "raza/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ race: data.contenido[0].raza });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDataCita = () => {
    var data = { id_cita: this.props.data.id_cita };

    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/consultarpaciente", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState(
          {
            services: data.contenido.servicios.servicios,
            infoAdmissionPatient: data.contenido,
          },
          () => this.getThird(data.contenido.idCliente)
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  getThird = (id) => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "tercero/ver/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ third: data.contenido[0] });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  calculateAge = (birthday) => {
    let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
    let nacimiento = moment(birthday).format("YYYY-MM-DD");
    let hoy = new Date();
    this.setState({
      age: fecha,
      birthday: nacimiento,
      today: moment(hoy).format("LLL"),
      day: moment(hoy).format("LL"),
    });
  };

  makePdfEvent = async () => {
    const data = {
      today: this.state.today,
      urlLogo: this.state.urlLogo,
      names:
        this.state.names +
        " " +
        this.state.firstLastName +
        " " +
        this.state.secondLastName,
      day: this.state.day,
      ordenes: this.state.ordenes,
      anamnesis: this.state.anamnesis,
      antecedentes: this.state.antecedentes,
      fisico: this.state.fisico,
      plan: this.state.plan,
      gender: this.state.gender,
      address: this.state.address,
      city: this.state.city,
      telephone: this.state.telephone,
      cellphone: this.state.cellphone,
      civilStatus: this.state.civilStatus,
      bloodType: this.state.bloodType,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      profile: this.state.profile,
      age: this.state.age,
      birthday: this.state.birthday,
      professional: this.state.professional,
      id_profesional: this.state.id_profesional,
      speechTerapy: this.state.speechTerapy,
      radioPharmacy: this.state.radioPharmacy,
      medicalRegister: this.state.medicalRegister,
      diagnostico: this.state.diagnostico,
      notas_clinicas: this.state.clinicNotes,
      sistemas: this.state.sistemas,
      third: this.state.third,
      infoAdmission: this.state.infoAdmissionPatient,
      regime: this.state.regime,
      infoIncapacityCurrentAdmision: this.state.incapacityByThisAdmission,
      thirdName: this.props.data.thirdsName,
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctor,
      firmDoctorSupport: this.state.firmDoctorSupport,
      occupation: this.state.occupation,
      disability: this.state.disability?.discapacidad,
      poblacionVulnerable: this.state.poblacionVulnerable,
    };

    if (
      this.state.isConsulta !== false &&
      this.state.validateService !== true
    ) {
      if (this.state.anamnesis !== undefined) {
        this.setState({ showPDf: true, showFileProcedure: false });
        await pdfEvent(data);
      } else {
        alert("No se ha guardado o cerrado la Historia Clínica");
      }
    }

    if (
      this.state.isConsulta !== true &&
      this.state.validateService !== false
    ) {
      if (
        this.state.medicalRegister !== null &&
        this.state.medicalRegister !== undefined
      ) {
        this.setState({ showPDf: true, showFileProcedure: false });
        await pdfEvent(data);
      } else {
        alert("No se ha guardado o cerrado el Registro Clínico");
      }
    }
  };

  makePdfHistory = (opt) => {
    const data = {
      today: this.state.today,
      urlLogo: this.state.urlLogo,
      names:
        this.state.names +
        " " +
        this.state.firstLastName +
        " " +
        this.state.secondLastName,
      day: this.state.day,
      ordenes: this.state.ordenes,
      admissions: this.state.admissions,
      gender: this.state.gender,
      address: this.state.address,
      city: this.state.city,
      telephone: this.state.telephone,
      cellphone: this.state.cellphone,
      civilStatus: this.state.civilStatus,
      bloodType: this.state.bloodType,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      profile: this.state.profile,
      age: this.state.age,
      birthday: this.state.birthday,
      id_admision: this.props.data.id_admision,
      professional: this.state.professional,
      id_historia: this.props.data.id_historia,
      infoIncapacityCurrentAdmision: this.state.incapacityByThisAdmission,
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctor,
      firmDoctorSupport: this.state.firmDoctorSupport,
      occupation: this.state.occupation,
      disability: this.state.disability?.discapacidad,
      poblacionVulnerable: this.state.poblacionVulnerable,
    };
    if (opt !== "Email") {
      this.setState({ showPDf: true, showFileProcedure: false });
      if (opt === "currentHistory") {
        pdfClincHistory(data, opt, null, true);
      } else {
        pdfClincHistory(data, opt, null);
      }
    } else {
      this.setState({ loadingSendEmail: true }, () => {
        if (this.state.correosEnviar.length < 0) {
          alert(
            "Debe escribir los Correos Electronicos a los cuales ira dirigido el Documento"
          );
          this.setState({ loadingSendEmail: false });
        } else {
          pdfClincHistory(data, opt, this.state.correosEnviar).then(() => {
            this.setState({
              loadingSendEmail: false,
              correosEnviar: [],
              correosEnviados: true,
            });
          });
        }
      });
    }
  };

  makePdfFormula = () => {
    const data = {
      from: "IMP", //Desde donde se consulta la Formula IMP(impresiones/listadoHC o Admisiones) HC desde dentro de Historia Clinica
      today: this.state.today,
      urlLogo: this.state.urlLogo,
      names:
        this.state.names +
        " " +
        this.state.firstLastName +
        " " +
        this.state.secondLastName,
      day: this.state.day,
      ordenes: this.state.ordenes,
      gender: this.state.gender,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      profile: this.state.profile,
      age: this.state.age,
      birthday: this.state.birthday,
      id_admision: this.props.data.id_admision,
      regime: this.state.regime,
      bloodType: this.state.bloodType,
      professional: this.state.professional,
      id_historia: this.props.data.id_historia,
      id_profesional: this.state.id_profesional,
      third: this.state.third,
      infoAdmission: this.state.infoAdmissionPatient,
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctor,
      firmDoctorSupport: this.state.firmDoctorSupport,
    };

    if (
      typeof this.state.ordenes !== "undefined" &&
      this.state.ordenes !== null
    ) {
      if (!!this.state.ordenes.ordenes?.ordenes?.formulas.length) {
        this.setState({ showPDf: true, showFileProcedure: false });
        pdfFormula(data);
      } else {
        alert("No se han registrado los datos de la formula medica");
      }
    } else {
      alert("No se han registrado los datos de la formula medica");
    }
  };

  makePdfProcedure = () => {
    if (
      typeof this.state.ordenes !== "undefined" &&
      this.state.ordenes !== null
    ) {
      if (!!this.state.ordenes.ordenes?.ordenes?.addedDiagnostics.length) {
        const data = {
          from: "IMP",
          today: this.state.today,
          urlLogo: this.state.urlLogo,
          names:
            this.state.names +
            " " +
            this.state.firstLastName +
            " " +
            this.state.secondLastName,
          gender: this.state.gender,
          typeOfDocument: this.state.typeOfDocument,
          documentNumber: this.state.documentNumber,
          profile: this.state.profile,
          age: this.state.age,
          day: this.state.day,
          birthday: this.state.birthday,
          regime: this.state.regime,
          bloodType: this.state.bloodType,
          ordenes: this.state.ordenes,
          professional: this.state.professional,
          id_profesional: this.state.id_profesional,
          id_historia: this.props.data.id_historia,
          diagnosticoCie10: this.state.diagnostico,
          third: this.state.third,
          infoAdmission: this.state.infoAdmissionPatient,
          medicoApoyo: this.state.medicoApoyo,
          firmDoctor: this.state.firmDoctor,
          firmDoctorSupport: this.state.firmDoctorSupport,
        };
        this.setState({ showPDf: true, showFileProcedure: false });
        console.log("dataPROCEDURE", data);
        pdfProceduresFormat(data);
      } else {
        alert("No se han agregado procedimientos al paciente");
      }
    } else {
      alert("No se han agregado procedimientos al paciente");
    }
  };

  loadCertTemplete = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "pantillas-cert-admision/listar",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ha ocurrido un error en el servidor");
          }
        })
        .then((data) => {
          console.log("dataPlantilla", data);

          if (data !== undefined && data !== null) {
            if (data.length > 0) {
              resolve(data);
            } else {
              resolve([]);
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };

  findAndReplaceInText = (text, searchedCharacter, replaceCharacter) => {
    const search = searchedCharacter;
    const replaceWith = replaceCharacter;
    const result = text.split(search).join(replaceWith);
    return result;
  };

  makePdfAdmsionFormat = async () => {
    let infoTempleteCertAdmission = await this.loadCertTemplete();
    let patientName =
      this.state.names +
      " " +
      this.state.firstLastName +
      " " +
      this.state.secondLastName;
    let plantillaCertAdmision = null;
    let proffesionalName =
      this.state.professional !== undefined && this.state.professional !== null
        ? this.state.professional.nombres +
          " " +
          this.state.professional.apellido1 +
          " " +
          this.state.professional.apellido2
        : "";
    let replaceInText = ["<p>", "</p>"];

    if (
      infoTempleteCertAdmission !== undefined &&
      infoTempleteCertAdmission !== null
    ) {
      if (infoTempleteCertAdmission[0].plantilla_certificado_admision !== "") {
        let servicesAdmission = "";
        if (
          this.props.data.servicios !== null &&
          this.props.data.servicios !== undefined
        ) {
          this.props.data.servicios.reduce((acc, current) => {
            servicesAdmission = servicesAdmission.concat(
              current.nombre + " - "
            );
          }, "");
        }
        plantillaCertAdmision =
          infoTempleteCertAdmission[0].plantilla_certificado_admision.toString();
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{paciente}",
          patientName
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{procedimiento}",
          servicesAdmission
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{identidad}",
          this.state.documentNumber
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{tipo_identidad}",
          this.state.typeOfDocument
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{empresa}",
          this.state.profile?.nombre
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{profesional}",
          proffesionalName
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "{direccion}",
          this.state.profile?.direccion?.direccion
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "<p>",
          "<div>"
        );
        plantillaCertAdmision = plantillaCertAdmision.replaceAll(
          "</p>",
          "</div>"
        );
      }
    }

    //replaceInText.map(character => plantillaCertAdmision= this.findAndReplaceInText() )

    const data = {
      today: this.state.today,
      urlLogo: this.state.urlLogo,
      names: patientName,
      gender: this.state.gender,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      servName: this.props.data.servName,
      profile: this.state.profile,
      id_admision: this.props.data.id_admision,
      fecha: this.props.data.fecha,
      hora: this.props.data.hora,
      birthday: this.state.birthday,
      age: this.state.age,
      celular: this.props.data.celular,
      telefono: this.props.data.telefono,
      direccion: this.props.data.direccion,
      professional: this.state.professional,
      servicios: this.props.data.servicios,
      id_profesional: this.state.id_profesional,
      regime: this.state.regime,
      thirdName: this.props.data.thirdsName,
      third: this.state.third,
      infoAdmission: this.state.infoAdmissionPatient,
      templete: plantillaCertAdmision,
      from: "IMP",
      plansName: this.props.data.planName,
    };
    this.setState({ showPDf: true, showFileProcedure: false });
    pdfAdmsionFormat(data);
  };

  makePdfConsent = () => {
    const data = {
      urlLogo: this.state.urlLogo,
      profile: this.state.profile,
      names:
        this.state.names +
        " " +
        this.state.firstLastName +
        " " +
        this.state.secondLastName,
      gender: this.state.gender,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      servName: this.props.data.servName,
      id_profesional: this.state.id_profesional,
    };

    this.setState({ showPDf: true, showFileProcedure: false });
    consentPdf(data);
  };

  makePdfNuclear = async () => {
    const data = {
      fullname:
        this.state.names +
        " " +
        this.state.firstLastName +
        " " +
        this.state.secondLastName,
      documentNumber: this.state.documentNumber,
      typeDocument: this.state.typeOfDocument,
      profile: this.state.profile,
      data: this.state.today,
      birthday: this.state.birthday,
      age: this.state.age,
      gender: this.state.gender,
      address: this.props.data.direccion,
      city: this.state.city,
      telephone: this.props.data.telefono,
      third: this.state.third, //
      regime: this.state.regime,
      services: this.state.services, //
      history: this.state.history,
      tecnic: this.state.tecnic,
      description: this.state.description,
      opinion: this.state.opinion,
      observation: this.state.observation,
      note: this.state.note,
      urlLogo: this.state.urlLogo,
      id_profesional: this.state.id_profesional,
      urlDoctor: this.state.firmDoctor,
      urlTech: this.state.firmTech,
      fullnameDoctor: this.state.fullnameDoctor,
      fullnameTech: this.state.fullnameTech,
    };
    this.setState({ showPDf: true, showFileProcedure: false });
    await generatePdf(data);
  };

  //una transcripcion para un solo audio
  printNuclearResults = async () => {
    let id_admision = parseInt(this.props.data.id_admision);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `admision-audios/consultar-impresion?id_admision=${id_admision}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        let dataQuery = res.info;
        let perfil = JSON.parse(sessionStorage.getItem("clinica"));

        let genderDoctor = dataQuery.sexo_doctor;
        let prefixDoctor = "Dr. ";
        switch (genderDoctor) {
          case "Masculino":
            prefixDoctor = "Dr. ";
            break;
          case "Femenino":
            prefixDoctor = "Dra. ";
            break;
        }
        let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
        let firmDoctor =
          process.env.REACT_APP_PUBLIC_URL +
          dataQuery.url_firma_doctor +
          "/" +
          sessionStorage.getItem("token");

        const dataPrint = {
          fullname: dataQuery.fullname,
          documentNumber: dataQuery.num_documento,
          typeDocument: dataQuery.tip_documento,
          profile: perfil,
          birthday: moment(dataQuery.fec_nacimiento).format("YYYY-MM-DD"),
          age: dataQuery.edad,
          gender: dataQuery.sexo,
          address: dataQuery.direccion.direccion,
          city: dataQuery.direccion.ciudad,
          telephone: dataQuery.telefono1,
          nitThird: dataQuery.nit_tercero,
          nameThird: dataQuery.nombre_tercero,
          regime: dataQuery.regimen_paciente,
          urlLogo: sessionStorage.getItem("logoURL"),
          transcription: dataQuery.transcripcion,
          nameDoctor: nameDoctor,
          specialtyDoctor: dataQuery.especialidad_doctor,
          medicalRegister: dataQuery.reg_medico,
          urlDoctorFirm: firmDoctor,
          id_admision: id_admision,
        };
        //this.setState({ showPDf: true,  showFileProcedure: false });
        PDFTranscription(dataPrint);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTranscription = async () => {
    let id_admision = parseInt(this.props.data.id_admision);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-transcripcion/consultar?id_admision=" +
        id_admision,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error");
        }
      })
      .then((res) => {
        if (res.transcripcion != null && res.transcripcion != undefined) {
          this.setState({
            transcriptionData: res.transcripcion,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          transcriptionData: null,
        });
      });
  };

  //una transcipcion para varios audios
  printTranscription = async () => {
    let id_admision = parseInt(this.props.data.id_admision);
    if (this.state.transcriptionData !== null) {
      await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `admision-transcripcion/consultar-impresion?id_admision=${id_admision}&id_transcripcion=${this.state.transcriptionData.id_transcripcion}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("RESPONSE", data);
          let dataQuery = data.info;
          console.log(dataQuery);

          let perfil = JSON.parse(sessionStorage.getItem("clinica"));
          let genderDoctor = dataQuery.sexo_doctor;
          let prefixDoctor = "Dr. ";
          switch (genderDoctor) {
            case "Masculino":
              prefixDoctor = "Dr. ";
              break;
            case "Femenino":
              prefixDoctor = "Dra. ";
              break;
          }
          let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
          let firmDoctor =
            process.env.REACT_APP_PUBLIC_URL +
            dataQuery.url_firma_doctor +
            "/" +
            sessionStorage.getItem("token");
          //let firmDoctorSupport = process.env.REACT_APP_PUBLIC_URL + dataQuery?.medico_apoyo?.url_firma_doctor_alter + '/' + sessionStorage.getItem('token');
          let firmDoctorSupport = dataQuery?.medico_apoyo?.map((medico) => {
            return (
              process.env.REACT_APP_PUBLIC_URL +
              medico.url_firma_doctor_alter +
              "/" +
              sessionStorage.getItem("token")
            );
          });
          //console.log(firmDoctorSupport);
          console.log("dataQuery", dataQuery.servicio.servicios[0]);

          let nameService = dataQuery.servicio.servicios[0].nombre;
          let codigoService = dataQuery.servicio.servicios[0].codigo;

          const dataPrint = {
            today: this.state.today,
            fullname: dataQuery.fullname,
            documentNumber: dataQuery.num_documento,
            typeDocument: dataQuery.tip_documento,
            profile: perfil,
            birthday: moment(dataQuery.fec_nacimiento).format("YYYY-MM-DD"),
            age: dataQuery.edad,
            gender: dataQuery.sexo,
            address: dataQuery.direccion.direccion,
            city: dataQuery.direccion.ciudad,
            telephone: dataQuery.telefono1,
            nitThird: dataQuery.nit_tercero,
            nameThird: dataQuery.nombre_tercero,
            regime: dataQuery.regimen_paciente,
            urlLogo: sessionStorage.getItem("logoURL"),
            transcription: dataQuery.transcripcion,
            nameDoctor: nameDoctor,
            specialtyDoctor: dataQuery.especialidad_doctor,
            medicalRegister: dataQuery.reg_medico,
            urlDoctorFirm: firmDoctor,
            nameService: nameService,
            codigoService: codigoService,
            id_admision: id_admision,
            fecha_admision: dataQuery.fecha_admision,
            celular: dataQuery.celular,
            suportDoc: dataQuery.medico_apoyo || null,
            firmDoctorSupport,
          };
          PDFTranscription(dataPrint);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      alert("No existe aún una transcripcion aprobada");
    }
  };

  getInformedConsent = async () => {
    let id_admision = parseInt(this.props.data.id_admision);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-consentimiento-informado/consultar?id_admision=" +
        id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(
            "Ha ocurrido un error cargando el consentimiento informado, es posible que no se halla diligenciado"
          );
        }
      })
      .then((data) => {
        if (
          data.consentimiento_informado != null &&
          data.consentimiento_informado != undefined
        ) {
          this.setState({
            informedConsent: data.consentimiento_informado.consentimiento,
          });

          //Recoleccion de Firmas
          let dataConsentimientoInformado = data.consentimiento_informado;
          dataConsentimientoInformado.firma_paciente = null;
          dataConsentimientoInformado.firma_primer_testigo = null;
          dataConsentimientoInformado.firma_segundo_testigo = null;

          if (
            dataConsentimientoInformado.firma_doctor != null &&
            dataConsentimientoInformado.firma_doctor != undefined
          ) {
            dataConsentimientoInformado.firma_doctor =
              process.env.REACT_APP_PUBLIC_URL +
              dataConsentimientoInformado.firma_doctor +
              "/" +
              sessionStorage.getItem("token");
          }

          if (
            dataConsentimientoInformado.firma_tecnologo != null &&
            dataConsentimientoInformado.firma_tecnologo != undefined
          ) {
            dataConsentimientoInformado.firma_tecnologo =
              process.env.REACT_APP_PUBLIC_URL +
              dataConsentimientoInformado.firma_tecnologo +
              "/" +
              sessionStorage.getItem("token");
          }

          if (data.consentimiento_informado.firmas_digitales) {
            let firmasDigitalesConsentimiento =
              data.consentimiento_informado.firmas_digitales.firmas.filter(
                (fir) => fir != null
              );

            let firmaPaciente = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "paciente"
            );
            if (firmaPaciente != undefined && firmaPaciente != null) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaPaciente.url_file_firma +
                sessionStorage.getItem("token");
              //setPatientSignature(firma);
              dataConsentimientoInformado.firma_paciente = firma;
            }

            let firmaPrimerTestigo = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "primer_testigo"
            );
            if (firmaPrimerTestigo != undefined && firmaPrimerTestigo != null) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaPrimerTestigo.url_file_firma +
                sessionStorage.getItem("token");
              //setFirstWitnessSignature(firma);
              dataConsentimientoInformado.firma_primer_testigo = firma;
            }

            let firmaSegundoTestigo = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "segundo_testigo"
            );
            if (
              firmaSegundoTestigo != undefined &&
              firmaSegundoTestigo != null
            ) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaSegundoTestigo.url_file_firma +
                sessionStorage.getItem("token");
              //setSecondWitnessSignature(firma);
              dataConsentimientoInformado.firma_segundo_testigo = firma;
            }
          }
          //Info del consentimiento informado
          //setDataPDF(dataConsentimientoInformado);
          this.printPDFConsent(dataConsentimientoInformado);
        } else {
          //alert("El Consentimiento Informado no se ha diligenciado aún");
          this.makePdfConsent();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  printPDFConsent = (consentInfo) => {
    console.log("Consentimiento", consentInfo);
    if (consentInfo !== null && consentInfo !== undefined) {
      this.setState({ showPDf: true, showFileProcedure: false });
      InformedConsentPDF(consentInfo);
    } else {
      alert("El Consentimiento Informado no se ha diligenciado aún");
    }
  };

  searchResultsProcedure = (nameProcedure) => {
    let nameProc = nameProcedure.toLowerCase();
    if (
      this.state.eventClinicProcedures !== null &&
      this.state.eventClinicProcedures !== undefined
    ) {
      if (this.state.eventClinicProcedures.hasOwnProperty(nameProc)) {
        let result_procedure =
          this.state.eventClinicProcedures.hasOwnProperty(nameProc);
        console.log("RES", result_procedure);
      }
    }
  };

  getListRadipharmacyDosse = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "admision-radiofarmaco/listar-por-admision?id_admision=" +
          this.props.data.id_admision,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ha ocurrido un error en el servidor");
          }
        })
        .then((data) => {
          if (data.length > 0) {
            resolve(data);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          resolve([]);
          console.error("Error:", error);
        });
    });
  };

  printSpeechTerapy = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `historia-informe/consultar-pdf?id_admision=${this.props.data.id_admision}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        let dataQuery = res.info;
        let perfil = JSON.parse(sessionStorage.getItem("clinica"));
        let genderDoctor = dataQuery.sexo_doctor;
        let prefixDoctor = "Dr. ";
        switch (genderDoctor) {
          case "Masculino":
            prefixDoctor = "Dr. ";
            break;
          case "Femenino":
            prefixDoctor = "Dra. ";
            break;
        }
        let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
        let firmDoctor =
          process.env.REACT_APP_PUBLIC_URL +
          dataQuery.url_firma_doctor +
          "/" +
          sessionStorage.getItem("token");
        let nameService = dataQuery.servicio.servicios[0].nombre;
        let codigoService = dataQuery.servicio.servicios[0].codigo;
        let resultados = dataQuery.procedimiento.fonoaudiologia;
        let fecha_salida = dataQuery.procedimiento.fecha;
        let responsable =
          dataQuery.representante_legal[0] != undefined
            ? dataQuery.representante_legal[0].nombre_completo
            : "";
        let diagnostico = null;

        if (dataQuery.diagnostico != null) {
          if (dataQuery.diagnostico.diagnostico.diagnostico.length > 0) {
            diagnostico = dataQuery.diagnostico.diagnostico.diagnostico;
          }
        }

        const dataPrint = {
          fullname: dataQuery.fullname,
          documentNumber: dataQuery.num_documento,
          typeDocument: dataQuery.tip_documento,
          profile: perfil,
          birthday: moment(dataQuery.fec_nacimiento).format("DD/MM/YYYY"),
          age: calculateAgeParse(dataQuery.fec_nacimiento),
          gender: dataQuery.sexo,
          address: dataQuery.direccion.direccion,
          city: dataQuery.direccion.ciudad,
          job: dataQuery.ocupacion,
          telephone: dataQuery.telefono1,
          cellphone: dataQuery.celular,
          nitThird: dataQuery.nit_tercero,
          nameThird: dataQuery.nombre_tercero,
          regime: dataQuery.regimen_paciente,
          urlLogo: sessionStorage.getItem("logoURL"),
          speechTerapy: resultados,
          nameDoctor: nameDoctor,
          specialtyDoctor: dataQuery.especialidad_doctor,
          medicalRegister: dataQuery.reg_medico,
          urlDoctorFirm: firmDoctor,
          nameService: nameService,
          codigoService: codigoService,
          dateAdmision: moment(dataQuery.fecha_admision).format("DD/MM/YYYY"),
          hourAdmision: moment(dataQuery.hora_admision, "HH:mm:ss").format(
            "h:mm:ss a"
          ),
          responsable: responsable,
          anamnesis: dataQuery.anamnesis,
          diagnostico: diagnostico,
          dateOutPatient: moment(fecha_salida).format("DD/MM/YYYY"),
          hourOutPatient: moment(fecha_salida).format("h:mm:ss a"),
          remitentDoctor: dataQuery.remitente,
        };

        this.setState(
          {
            showPDf: true,
            showFileProcedure: false,
          },
          () => {
            SpeechTerapyPDF(dataPrint);
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  printPDFInfoProcedureLetter = () => {
    let fechaIngreso = this.props.data.fecha_ingreso_admision;
    if (
      this.props.data.fecha_ingreso_admision != null &&
      this.props.data.fecha_ingreso_admision != undefined
    ) {
      fechaIngreso = this.props.data.fecha_ingreso_admision;
    } else {
      fechaIngreso = moment(this.props.data.fecha).format("DD/MM/YYYY");
    }

    let data = {
      namePatient: this.props.data.fullname,
      id: this.props.data.tip_documento + " " + this.props.data.num_documento,
      id_admision: this.props.data.id_admision,
      id_historia: this.props.data.id_historia,
      thirdName: this.props.data.nombre_tercero,
      serviceName: this.props.data.servName,
      dateProcedure: fechaIngreso,
      hourProcedure: this.props.data.fecha_ingreso_completa,
      professionalName: this.props.data.nombre_profesional,
      medicalRegister: this.state.medicalRegister,
      urlLogo: sessionStorage.getItem("logoURL"),
      profile: JSON.parse(sessionStorage.getItem("clinica")),
    };
    pdfPrintInfoLetterProcedure(data);
    this.setState({ showPDf: true, showFileProcedure: false });
  };

  handleSelecetedTags = (items) => {
    this.setState({ correosEnviar: items });
  };

  loadIncapacityByThisAdmission = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "incapacidades-clinicas/consultar-por-admision?id_admision=" +
        this.props.data.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("cargar incapacidad", data);
        if (!!data) {
          if (!!data.length) {
            this.setState({ incapacityByThisAdmission: data });
          } else {
            this.setState({ incapacityByThisAdmission: null });
          }
        } else {
          this.setState({ incapacityByThisAdmission: null });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  printPDFIncapacity = async () => {
    const profile = JSON.parse(sessionStorage.getItem("clinica"));
    const urlLogo = sessionStorage.getItem("logoURL");
    let searchDiagnosticByAdmission = this.state.admissions.find(
      (adm) => adm.id_admision === parseInt(this.props.data.id_admision)
    );
    let diagnosticByAdmission = !!searchDiagnosticByAdmission
      ? searchDiagnosticByAdmission.hasOwnProperty("diagnostico")
        ? searchDiagnosticByAdmission.diagnostico
        : null
      : null;
    let addedDiagnostics = [];
    let observations = [];
    let infoProfessional = this.state.professional;
    infoProfessional.id_profesional = this.state.id_profesional;

    if (!!diagnosticByAdmission) {
      diagnosticByAdmission.diagnostico?.diagnostico.forEach((diag) => {
        addedDiagnostics.push(diag);
        observations.push(diag.observacion);
      });
    }

    let diagnostic = { addedDiagnostics, observations };
    /* let dataCitaInfoSentToCreateReceipt = await loadDataCitaToCreateReceipt(parseInt(data.id_cita));
        let idPlan = !!dataCitaInfoSentToCreateReceipt ? dataCitaInfoSentToCreateReceipt.idPlan : null; */
    let diagnosticsByThisAdmission = diagnostic.addedDiagnostics;

    if (!!diagnosticByAdmission?.diagnostico?.diagnostico.length) {
      const dataToSend = {
        fecha: moment(this.props.data.fecha_ingreso_completa_admision).format(
          "DD-MM-YYYY"
        ),
        hora: moment(this.props.data.fecha_ingreso_completa_admision).format(
          "HH:mm"
        ),
        typeOfDocument: this.props.data.tip_documento,
        documentNumber: this.props.data.num_documento,
        birthday: this.props.data.birthday,
        names: this.props.data.fullname,
        direccion: this.props.data?.adress?.direccion,
        celular: this.props.data.telephone,
        professional: this.state.professional,
        infoAdmission: this.state.infoAdmissionPatient,
        profile: profile,
        urlLogo: urlLogo,
        thirdName: this.state.third?.nombre,
        diagnostics: diagnostic,
        observations: this.state.incapacityByThisAdmission[0]?.observaciones,
        startDateIncapacity:
          this.state.incapacityByThisAdmission[0]?.fecha_incial,
        endDateIncapacity: this.state.incapacityByThisAdmission[0]?.fecha_final,
        infoIncapacityCurrentAdmision: this.state.incapacityByThisAdmission,
      };
      this.setState({ showPDf: true, showFileProcedure: false });
      incapacityPDF(dataToSend);
    } else {
      alert("No se ha seleccionado ningún diagnostico para esta admisión");
    }
  };

  makePdfYodo = async () => {
    const profile = JSON.parse(sessionStorage.getItem("clinica"));
    const urlLogo = sessionStorage.getItem("logoURL");

    const data = {
      urlLogo,
      profile,
      admissions: this.state.admissions,
      typeOfDocument: this.props.data.tip_documento,
      documentNumber: this.props.data.num_documento,
      birthday: this.props.data.birthday,
      names: this.props.data.fullname,
      address: this.props.data?.adress?.direccion,
      gender: this.state.gender,
      cellphone: this.props.data.telephone,
      regimen: this.state.infoAdmissionPatient.contrato.nom_regimen,
      entity: this.state.infoAdmissionPatient.third_info.nombre,
      age: calculateAgeParse(this.state.infoAdmissionPatient.f_nac),
      city: this.state.infoAdmissionPatient.direccion.ciudad,
      exam: this.state.infoAdmissionPatient.servicios.servicios[0].nombre,
      medicoApoyo: this.state.medicoApoyo,
      firmDoctor: this.state.firmDoctorGet,
      firmDoctorSupport: this.state.firmDoctorSupport,
      nombre_medicamento: this.state.infoAdmissionPatient?.nombre_medicamento,
      dosis_medicamento: this.state.infoAdmissionPatient?.dosis_medicamento,
      id_admision_actual: this.state.infoAdmissionPatient?.admision,
    };

    this.setState({ showPDf: true });
    pdfYodo(data);
  };

  showFileProcedure = (fileInfo) => {
    if (this.state.showPDf) this.setState({ showPDf: !this.state.showPDf });
    this.setState({
      showFileProcedure: true,
      showSelectedFile: fileInfo.wholeURL,
    });
  };

  handlerEmailRecipient = (action, emailToAdd, idx) => {
    const currentEmailRecipients = this.state.correosEnviar;
    if (action === "ADD") {
      const newEmailRecipients = [...currentEmailRecipients, emailToAdd];
      this.setState({ correosEnviar: newEmailRecipients });
    } else {
      const newEmailRecipients = currentEmailRecipients.splice(idx, 1);
      this.setState({ correosEnviar: newEmailRecipients });
    }
  };

  definePaientsEmailToSend = () => {
    if (!this.state.email.includes("NOTIENE")) {
      const newEmailRecipients = [
        ...this.state.correosEnviar,
        this.state.email,
      ];
      this.setState({ correosEnviar: newEmailRecipients });
    }
  };

  render() {
    return (
      <Col>
        <Row>
          <h4 style={{ marginBottom: 20 }}>Impresiones Paciente</h4>
          <div style={{ marginBottom: 10 }}>
            <Row>
              <Col md={6} sm={12}>
                <h5>
                  {" "}
                  <b> Nombre </b> {this.state.names} {this.state.firstLastName}{" "}
                  {this.state.secondLastName}
                </h5>
              </Col>
              <Col md={6} sm={12}>
                <h5>
                  {" "}
                  <b> Documento </b> {this.state.typeOfDocument}-
                  {this.state.documentNumber}
                </h5>
              </Col>
            </Row>
          </div>
        </Row>
        <Row>
          <div className="tabs tabs--justify tabs--bordered-top">
            <div className="tabs__wrap">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1",
                    })}
                    onClick={() => this.toggle("1")}
                    style={{ color: "#646777" }}
                  >
                    Impresiones en PDF
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "2",
                    })}
                    onClick={() => this.toggle("2")}
                    style={{ color: "#646777" }}
                  >
                    Envio por Correo Electronico
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <div className="top-pdf-print-clinic-event-modal">
                    <div style={{ marginTop: 10, width: "100%" }}>
                      {this.state.isConsulta !== false &&
                      this.state.validateService !== true ? (
                        <IconButton
                          size="small"
                          style={{ marginRight: 20 }}
                          onClick={() => {
                            this.makePdfEvent();
                          }}
                        >
                          <PictureAsPdfIcon
                            style={{
                              color:
                                this.state.anamnesis !== undefined
                                  ? "#28a745"
                                  : "#6c757d",
                            }}
                          />
                          Historia de la última atención
                        </IconButton>
                      ) : this.state.isConsulta !== true &&
                        this.state.validateService !== false ? (
                        <IconButton
                          size="small"
                          style={{ marginRight: 20 }}
                          onClick={() => {
                            this.makePdfEvent();
                          }}
                        >
                          <PictureAsPdfIcon
                            style={{
                              color:
                                this.state.medicalRegister !== null &&
                                this.state.medicalRegister !== undefined
                                  ? "#28a745"
                                  : "#6c757d",
                            }}
                          />
                          Registro Clínico
                        </IconButton>
                      ) : null}
                      <IconButton
                        size="small"
                        style={{ marginRight: 20 }}
                        onClick={() => {
                          this.makePdfHistory("PDF");
                        }}
                      >
                        <PictureAsPdfIcon
                          style={{
                            color: this.state.admissions.length
                              ? "#28a745"
                              : "#6c757d",
                          }}
                        />
                        Historia Completa
                      </IconButton>
                      {this.state.isConsulta !== false &&
                      this.state.validateService !== true ? (
                        <Fragment>
                          <IconButton
                            size="small"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                              this.makePdfFormula();
                            }}
                          >
                            <PictureAsPdfIcon
                              style={{
                                color:
                                  typeof this.state.ordenes !== "undefined" &&
                                  this.state.ordenes !== null
                                    ? !!this.state.ordenes.ordenes?.ordenes
                                        ?.formulas.length
                                      ? "#28a745"
                                      : "#6c757d"
                                    : "#6c757d",
                              }}
                            />
                            Formula
                          </IconButton>
                        </Fragment>
                      ) : null}
                      <IconButton
                        size="small"
                        style={{ marginRight: 20 }}
                        onClick={() => {
                          this.makePdfProcedure();
                        }}
                      >
                        <PictureAsPdfIcon
                          style={{
                            color:
                              typeof this.state.ordenes !== "undefined" &&
                              this.state.ordenes !== null
                                ? !!this.state.ordenes.ordenes?.ordenes
                                    ?.addedDiagnostics.length
                                  ? "#28a745"
                                  : "#6c757d"
                                : "#6c757d",
                          }}
                        />
                        Procedimiento
                      </IconButton>

                      {!!this.props.data.pertenece_estudio === false ? (
                        <IconButton
                          size="small"
                          style={{ marginRight: 20 }}
                          onClick={() => {
                            this.makePdfAdmsionFormat();
                          }}
                        >
                          <PictureAsPdfIcon />
                          Formato Admisión
                        </IconButton>
                      ) : null}

                      {this.state.isConsulta !== true ? (
                        this.state.validateService !== false ? (
                          <IconButton
                            size="small"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                              //Solamente se muestra cuando es una gamagrafía
                              this.getInformedConsent();
                            }}
                          >
                            <PictureAsPdfIcon />
                            Consentimiento
                          </IconButton>
                        ) : null
                      ) : null}

                      {this.state.listTypes.includes("3") &&
                      !this.state.isConsulta ? (
                        this.state.validateService !== false ? (
                          <>
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //resultados de gamagrafias
                                this.printTranscription();
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.transcriptionData !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados Procedimiento
                            </IconButton>
                          </>
                        ) : null
                      ) : null}

                      {this.state.listTypes.includes("3") &&
                      !this.state.isConsulta ? (
                        <IconButton
                          size="small"
                          style={{ marginRight: 20 }}
                          onClick={() => {
                            this.printPDFInfoProcedureLetter();
                          }}
                        >
                          <PictureAsPdfIcon />
                          Sobre de Resultados
                        </IconButton>
                      ) : null}

                      {this.state.listTypes.includes("3") &&
                      !this.state.isConsulta ? (
                        <IconButton
                          size="small"
                          style={{ marginRight: 20 }}
                          onClick={() => {
                            this.makePdfHistory("currentHistory");
                          }}
                        >
                          <PictureAsPdfIcon
                            style={{
                              color: this.state.admissions.length
                                ? "#28a745"
                                : "#6c757d",
                            }}
                          />
                          Atención actual
                        </IconButton>
                      ) : null}

                      {this.state.userPermits.includes(34) ? (
                        <>
                          <IconButton
                            size="small"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                              if (this.state.speechTerapyData != null) {
                                this.printSpeechTerapy();
                              } else {
                                alert(
                                  "No se ha diligenciado el Prodecimiento de Audiometria o Fonoaudiologia"
                                );
                              }
                            }}
                          >
                            <PictureAsPdfIcon
                              style={{
                                color:
                                  this.state.speechTerapyData !== undefined &&
                                  this.state.speechTerapyData !== null
                                    ? "#28a745"
                                    : "#6c757d",
                              }}
                            />
                            Resultados Fonoaudiologia
                          </IconButton>
                        </>
                      ) : null}

                      {!this.state.isConsulta &&
                      this.state.validateService == false ? (
                        <>
                          {this.state.existServicesProcedures.eco == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados ECO
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "ECO"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (ECO)
                            </IconButton>
                          ) : null}

                          {this.state.existServicesProcedures.stress == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados STRESS
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "STRESS"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (ESTRES)
                            </IconButton>
                          ) : null}

                          {this.state.existServicesProcedures.test == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados STRESS
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "TEST"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (PRUEBAS DE ESFUERZO)
                            </IconButton>
                          ) : null}

                          {this.state.existServicesProcedures.ekg == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados EKG
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "EKG"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (EKG)
                            </IconButton>
                          ) : null}

                          {this.state.existServicesProcedures.holter == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados HOLTER
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "HOLTER"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (HOLTER)
                            </IconButton>
                          ) : null}

                          {this.state.existServicesProcedures.mapa == true ? (
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                //Resultados MAPA
                                PrintsProceduresPDF.printPDF(
                                  parseInt(this.props.data.id_admision),
                                  "MAPA"
                                );
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color:
                                    this.state.eventClinicProcedures !==
                                      undefined &&
                                    this.state.eventClinicProcedures !== null
                                      ? "#28a745"
                                      : "#6c757d",
                                }}
                              />
                              Resultados (MAPA)
                            </IconButton>
                          ) : null}

                          {this.state.filesProceduresByThisAdmission && (
                            <Fragment>
                              <p>Archivos adjuntos: </p>
                              {this.state.filesProceduresByThisAdmission.map(
                                (filePrc) => (
                                  <IconButton
                                    size="small"
                                    style={{ marginRight: 20 }}
                                    onClick={() => {
                                      //Archivos adjuntos
                                      this.showFileProcedure(filePrc);
                                    }}
                                  >
                                    <PictureAsPdfIcon
                                      style={{ color: "#28a745" }}
                                    />
                                    {filePrc.adjunto}
                                  </IconButton>
                                )
                              )}
                            </Fragment>
                          )}
                        </>
                      ) : null}
                      {this.state.validateTerapy == true ? (
                        <>
                          <IconButton
                            size="small"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                              !this.state.incapacityByThisAdmission ||
                              this.state.incapacityByThisAdmission.length === 0
                                ? alert("No se ha diligenciado la incapacidad ")
                                : this.printPDFIncapacity();
                            }}
                          >
                            <PictureAsPdfIcon
                              style={{
                                color:
                                  this.state?.incapacityByThisAdmission !== null
                                    ? "#28a745"
                                    : "#6c757d",
                              }}
                            />
                            Incapacidad
                          </IconButton>

                          <IconButton
                            size="small"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                              this.state.infoAdmissionPatient === null
                                ? alert(
                                    "No se ha diligenciado certificado de yodo "
                                  )
                                : this.makePdfYodo();
                            }}
                          >
                            <PictureAsPdfIcon
                              style={{
                                color:
                                  this.state?.infoAdmissionPatient !== null
                                    ? "#28a745"
                                    : "#6c757d",
                              }}
                            />
                            Certificado de Yodo
                          </IconButton>
                        </>
                      ) : null}
                    </div>
                  </div>
                </TabPane>
              </TabContent>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="2">
                  {this.state.activeTab == "2" ? (
                    <>
                      {this.state.loadingSendEmail == false ? (
                        <>
                          <Row>
                            {/* <SendEmails emails={this.state.correosEnviar} handlerEmailRecipient={this.handlerEmailRecipient()} /> */}
                            <Col md={12}>
                              <TagsInput
                                selectedTags={this.handleSelecetedTags}
                                fullWidth
                                variant="standard"
                                id="tags"
                                name="tags"
                                placeholder="Agregar Correos"
                                label="Correos a Enviar"
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                }}
                                emailValue={true}
                                defaultTags={this.state.correosEnviar}
                              />

                              {/*
                                                    <TextField
                                                        required
                                                        id="document-standard-required"
                                                        label="Correo Electronico"
                                                        className="medical-material-form__field"
                                                        type="email"
                                                        style={{ width: '100%' }}
                                                        value={this.state.emailDestiny}
                                                        onChange={(e) => {
                                                            this.setState({ emailDestiny: e.target.value })
                                                        }}
                                                        InputLabelProps={{
                                                            style: { color: '#646777' }
                                                        }}
                                                    />*/}
                            </Col>
                          </Row>

                          <div style={{ marginTop: 10 }}>
                            <IconButton
                              size="small"
                              style={{ marginRight: 20 }}
                              onClick={() => {
                                this.makePdfHistory("Email");
                              }}
                            >
                              <PictureAsPdfIcon
                                style={{
                                  color: this.state.admissions.length
                                    ? "#28a745"
                                    : "#6c757d",
                                }}
                              />
                              Historia Completa
                            </IconButton>
                          </div>
                          <br />
                          {this.state.correosEnviados == true ? (
                            <h4 className="text-success">
                              Correo Enviado Correctamente
                            </h4>
                          ) : null}
                        </>
                      ) : (
                        <div className="text-center">
                          <label>
                            Procesando Documento y Enviando el Correo
                            Electronico por favor espere...
                          </label>
                          <Spinner animation="border" variant="success" />
                        </div>
                      )}
                    </>
                  ) : null}
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Row>
        <Row>
          {this.state.showPDf ? (
            <div className="container-pdfs-modal">
              <iframe
                className="iframe-pdfs"
                id="pdfV"
                title="pdf-report"
              ></iframe>
            </div>
          ) : null}
          {this.state.showSelectedFile && this.state.showFileProcedure ? (
            <div className="container-pdfs-modal">
              <iframe
                className="iframe-pdfs"
                id="pdfV_file"
                title="pdf-report"
                src={this.state.showSelectedFile}
              ></iframe>
            </div>
          ) : null}
        </Row>
      </Col>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ShowClinicEvent);
